import * as angular from 'angular';

export const FiltersModule = angular.module('app.filters', []);
